import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch('/products.json', { cache: 'no-store' });
        const data = await res.json();
        setItems(data.items || []);
      } catch (e) {
        setError('Failed to load product.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const product = useMemo(() => items.find((p) => p.id === id), [items, id]);

  const onBuy = () => {
    if (product?.paymentLink) {
      window.location.assign(product.paymentLink);
    }
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (error || !product) {
    return (
      <Container className="py-5">
        <Card className="p-4 text-center">
          <h4 className="mb-3">{error || 'Product not found'}</h4>
          <Button variant="secondary" onClick={() => navigate('/products')}>Back to Products</Button>
        </Card>
      </Container>
    );
  }

  return (
    <div className="product-detail-page">
      <Container className="py-4">
        <Row className="g-4">
          <Col md={7}>
            <Card className="h-100 shadow-sm">
              <Card.Img variant="top" src={product.image} alt={product.title} />
              <Card.Body>
                <div className="mb-2">
                  {product.badges && product.badges.map((b, i) => (
                    <span key={i} className="badge bg-warning text-dark me-2">{b}</span>
                  ))}
                </div>
                <h3 className="mb-3">{product.title}</h3>
                <p className="text-muted mb-0">{product.description}</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5}>
            <Card className="h-100 shadow-sm p-3">
              <div className="mb-3">
                <div className="text-muted">Price</div>
                <div className="display-6 fw-bold">₹{product.price}</div>
              </div>
              <div className="d-grid gap-2">
                <Button size="lg" variant="primary" onClick={onBuy}>Buy Now</Button>
                <Button variant="outline-secondary" onClick={() => navigate('/products')}>Back to Products</Button>
              </div>
              <div className="mt-4 small text-muted">
                Secure payment via Razorpay. You will be redirected to complete the purchase.
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductDetail;
